import styled, { css } from "styled-components"

export const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;

  /* Native InfoWindow customization — Google injects fixed markup, we override it.
     These rules are scoped to .gm-style so they only affect Google Maps panels. */
  .gm-style .gm-style-iw {
    border-radius: 12px !important;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12) !important;
    padding: 0 !important;
  }

  .gm-style .gm-style-iw-c {
    border-radius: 12px !important;
    padding: 0 !important;
  }

  .gm-style .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
  }

  /* Hide the default arrow tail — our InfoWindow has its own visual anchoring */
  .gm-style .gm-style-iw-tc {
    display: none !important;
  }

  /* Collapse the chrome bar that Google injects above the content to host the
     close button — it adds an unwanted white band above our colored header.
     We pull it out of the layout flow and float the X button over the header. */
  .gm-style .gm-style-iw-chr {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    height: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    z-index: 2;
  }

  .gm-style .gm-ui-hover-effect {
    position: absolute !important;
    top: -2px !important;
    right: 10px !important;
    width: 24px !important;
    height: 24px !important;
    opacity: 0.85;
  }

  /* Recolor the X icon white so it stays visible over the colored header */
  .gm-style .gm-ui-hover-effect > span {
    background-color: #ffffff !important;
    margin: 6px !important;
  }
`

export const LocalisationInputContainer = styled.div`
  display: flex;
  width: 100%;
`

export const LocalisationInputController = styled.div`
  width: 50%;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`

export const LocalisationTitle = styled.h3`
  text-transform: uppercase;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  margin: 10px 0;
  color: #787878;
  display: flex;
`

export const InputTitle = styled.div`
  align-items: center;
  margin: 0 0 10px 0;
  font-weight: 600;
  font-size: 15px;
  color: #787878;
  display: flex;
`

export const SelectIconsContainer = styled.div`
  position: relative;
  height: 100px;
  width: 100%;
`

export const FlexContainer = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
`

export const IconContainer = styled.div`
  flex-direction: column;
  align-items: center;
  position: relative;
  font-size: 30px;
  display: flex;
  height: 100%;
  width: 70px;

  .icon {
    color: ${({ primaryActionColor }) => primaryActionColor || "#707070"};
    height: 40px;
  }
  .check_container {
    justify-content: center;
    align-items: center;
    display: flex;
    height: 30px;
    width: 70px;

    .checkbox {
      border: 1px solid #707070;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      font-size: 14px;
      display: flex;
      height: 20px;
      width: 20px;

      i {
        color: ${({ primaryActionColor }) => primaryActionColor || "#707070"};
      }
    }
  }
`
